<template>
   <div class="content work_wrapper search_content simple_content">
        <v-row class="search_box">
            <v-col>
              <topNav></topNav>
            </v-col>
        </v-row>
        <div class="userInfo_wrapper">
            <v-row class="">
                <v-col sm="12" md="12">
                    <div class="center_box">
                        <div class="box_title">个人信息</div>
                        <div class="detail_content simple">
                            <!-- <div class="title1">基本信息</div> -->
                            <div class="line_style">
                                <div class="label">昵称</div>
                                <div class="text">{{userInfo.nickName}}</div>
                            </div>
                            <div class="line_style">
                                <div class="label">账户名</div>
                                <div class="text">{{userInfo.account}}</div>
                            </div>
                            <div class="line_style" v-if="userInfo.qqNickName">
                                <div class="label">QQ昵称</div>
                                <div class="text">{{userInfo.qqNickName}}</div>
                            </div>
                            <div class="line_style" v-if="userInfo.wxNickname">
                                <div class="label">微信昵称</div>
                                <div class="text">{{userInfo.wxNickname}}</div>
                            </div>
                            <div class="line_style">
                                <div class="label">手机号</div>
                                <div class="text">{{userInfo.phone}}</div>
                            </div>
                             <div class="line_style">
                                <div class="label">邮箱</div>
                                <div class="text">{{userInfo.email}}</div>
                            </div>
                            <div class="line_style" v-if="userInfo.enterpriseName">
                                <div class="label">公司名</div>
                                <div class="text">{{userInfo.enterpriseName}}</div>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
   </div>
</template>
<script>
import topNav from "@/components/widgets/topNav.vue";
import strategyList from "@/components/strategy/list.vue";
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            userInfo: {},
            historyList: [],
            headers: [
                {
                    text: '关键词',
                    align: 'start',
                    sortable: false,
                    value: 'keywords'
                },
                {
                    text: 'IP地址',
                    align: 'start',
                    sortable: false,
                    value: 'ip'
                },
                {
                    text: '检索式',
                    align: 'start',
                    sortable: false,
                    value: 'searchFormula'
                },
            ]
        }
    },
    components: {
        topNav,
        strategyList
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        ...mapActions('user',['personalInfo']),
        getInfo() {
            let _this = this
            let data = {
                params: {
                    tag: 'user_info'
                }
            }
            this.personalInfo({data: data,handle(res) {
                let info = res.user
                _this.userInfo = info
                console.log('res', res)
            }})
        },
    }
}
</script>